<template>
  <div class="abnormal-container">
    <star-condition-layout :onSearch="handleSearch" :onReset="reset" :loading="loading">
      <star-condition-cell label="异常类型">
        <a-select
          allowClear
          v-model="searchCondition.spiderErrorStatus"
          placeholder="请选择异常类型"
          style="width: 100%"
        >
          <a-select-option :value="0">解析率＜50% /h</a-select-option>
          <a-select-option :value="1">采集量＞1w条 /h</a-select-option>
          <a-select-option :value="2">24h内采集量为0</a-select-option>
        </a-select>
      </star-condition-cell>

      <star-condition-cell label="站点类型">
        <a-select allowClear v-model="searchCondition.spiderClassId" style="width: 100%">
          <a-select-option
            v-for="item in spiderClassOptions"
            :key="item.spiderClassId"
            :value="item.spiderClassId"
            >{{ item.spiderClassName }}
          </a-select-option>
        </a-select>
      </star-condition-cell>

      <star-condition-cell label="站点ID">
        <a-input v-model="searchCondition.spiderId"></a-input>
      </star-condition-cell>

      <star-condition-cell label="告警日期">
        <a-range-picker
          style="width: 135%"
          v-model="searchCondition.publishTime"
          :show-time="{ format: 'HH:mm:ss' }"
          value-format="YYYY-MM-DD HH:mm:ss"
          :placeholder="['开始日期', '结束日期']"
        />
      </star-condition-cell>
    </star-condition-layout>

    <div class="table-container">
      <TableHeadIcons :onRefresh="handleSearch" :size.sync="tableDensity" :columns="columns" />

      <a-table
        :size="tableDensity"
        :loading="loading"
        :pagination="pagination"
        @change="handleTableChange"
        rowKey="spiderErrorRecordId"
        :columns="showColumns"
        :data-source="tableData"
      >
        <span slot="index" slot-scope="text, record, index">{{ index + 1 }}</span>
        <span slot="spiderId" slot-scope="text">
          <a-tooltip>
            <template slot="title"> {{ text }} </template>
            <span>
              {{ text }}
            </span>
          </a-tooltip>

          <a-tooltip>
            <template slot="title"> 复制 </template>
            <a
              href="javascript:;"
              v-clipboard:copy="text"
              v-clipboard:success="onCopy"
              v-clipboard:error="onCopyError"
            >
              <a-icon type="copy" />
            </a>
          </a-tooltip>
        </span>
        <span slot="spiderName" slot-scope="text">
          <a-tooltip>
            <template slot="title"> {{ text }} </template>
            <span>
              {{ text }}
            </span>
          </a-tooltip>

          <a-tooltip>
            <template slot="title"> 复制 </template>
            <a
              href="javascript:;"
              v-clipboard:copy="text"
              v-clipboard:success="onCopy"
              v-clipboard:error="onCopyError"
            >
              <a-icon type="copy" />
            </a> </a-tooltip
        ></span>
        <span slot="spiderErrorStatus" slot-scope="label">
          <span v-if="label === 0">解析率低</span>
          <span v-if="label === 1">结果集过大</span>
          <span v-if="label === 2">长时间没有更新</span>
        </span>
        <div slot="action" slot-scope="text, record">
          <a-button type="link" @click="handleInfo(record)">站点详情 </a-button>
          <a-divider type="vertical"></a-divider>
          <a-button type="link" @click="handleMinager(record)">异常任务 </a-button>
        </div>
      </a-table>
    </div>
  </div>
</template>

<script>
import { getAbNormalListApi } from '@/api/Monitor/abnormal'
import { querySpiderClassInfoApi } from '@/api/Site/Type'
import { onHttpResponseSilent } from '@/utils/request'
import tableSettingToStoreMixin from '@/mixin/tableSettingToStroe'
import Clipboard from 'clipboard'
import { message } from 'ant-design-vue'
export default {
  mixins: [tableSettingToStoreMixin('abnormal')],

  data() {
    return {
      searchCondition: {
        spiderErrorStatus: undefined,
        spiderClassId: undefined,
        spiderId: undefined,
        publishTime: undefined
      },
      tableData: [],
      spiderClassOptions: [],
      columns: [
        {
          width: 60,
          title: '序号',
          align: 'center',
          show: true,
          scopedSlots: { customRender: 'index' }
        },
        {
          title: '站点Id',
          dataIndex: 'spiderId',
          show: true,
          align: 'center',
          scopedSlots: { customRender: 'spiderId' }
        },
        {
          title: '站点类型',
          dataIndex: 'spiderClassName',
          show: true,
          align: 'center'
        },
        {
          title: '站点名称',
          dataIndex: 'spiderName',
          show: true,
          align: 'center',
          scopedSlots: { customRender: 'spiderName' }
        },
        {
          title: '异常类型',
          dataIndex: 'spiderErrorStatusName',
          show: true,
          align: 'center'
        },
        {
          title: '检测时间',
          dataIndex: 'dateRangeStr',
          show: true,
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          show: true,
          align: 'center'
        }
      ],
      pagination: {
        current: 1,
        pageSize: 10,
        showTotal: (total) => `共 ${total} 条`,
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        size: 'default'
      },
      loading: false,
      tableDensity: 'middle'
    }
  },
  computed: {
    showColumns() {
      return this.columns.filter((item) => item.show)
    }
  },
  mounted() {
    const { errorCode } = this.$route.query
    if (errorCode !== undefined) {
      this.searchCondition.spiderErrorStatus = errorCode
    }
    const { name, time } = this.$route.query
    if (name !== undefined) {
      this.searchCondition.spiderErrorStatus = name
      this.searchCondition.publishTime = time
    }
    this.handleSearch()
    this.querySpiderClassInfo()
  },
  created() {},
  methods: {
    // 复制成功时的回调函数
    onCopy(e) {
      this.$message.success('已复制')
    },
    // 复制失败时的回调函数
    onCopyError(e) {
      this.$message.error('复制失败')
    },
    copy: function () {
      var _this = this
      var clipboard = new Clipboard('#copy_text')

      clipboard.on('success', (e) => {
        message.success('复制成功')
        // 释放内存
        clipboard.destroy()
      })
      clipboard.on('error', (e) => {
        // 不支持复制
        Message({
          message: '该浏览器不支持自动复制',
          type: 'warning'
        })
        // 释放内存
        clipboard.destroy()
      })
    },
    async querySpiderClassInfo() {
      let res = await querySpiderClassInfoApi()
      let { code, msg, data } = res
      if (code == '200') {
        this.spiderClassOptions = data
      } else {
        this.$message.error(msg)
      }
    },
    handleSearch() {
      this.pagination.current = 1
      this.getAbNormalList()
    },
    handleInfo({ spiderId, spiderClassType }) {
      this.$router.push({
        name: 'site_info',
        query: {
          spiderId,
          type: spiderClassType
        }
      })
    },
    handleMinager({ spiderId, errorStartTime, errorEndTime }) {
      this.$router.push({
        name: 'dispatch_task_manage',
        query: {
          spiderId: spiderId,
          errorStartTime: errorStartTime,
          errorEndTime: errorEndTime
        }
      })
    },
    reset() {
      this.searchCondition = {
        spiderErrorStatus: ''
      }
      this.handleSearch()
    },

    getAbNormalList() {
      let query = {
        pn: this.pagination.current,
        pageSize: this.pagination.pageSize,
        ...this.searchCondition
      }
      delete query.publishTime
      if (this.searchCondition.publishTime) {
        query.errorStartTime = this.searchCondition.publishTime[0]
        query.errorEndTime = this.searchCondition.publishTime[1]
      }
      getAbNormalListApi(query)
        .then(onHttpResponseSilent)
        .then((res) => {
          let { data, extra } = res
          this.tableData = data
          this.pagination.total = extra.page.pageCount || 0
        })
    },

    handleTableChange(pagination) {
      this.pagination = pagination
      this.getAbNormalList()
    }
  }
}
</script>

<style lang="less" scoped>
.abnormal-container {
  width: 100%;
  padding: 16px;

  .table-container {
    background-color: white;
    padding: 0 16px;
    margin-top: 16px;
  }
}
</style>
